"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const array_1 = require("../../../common/js/helper/array");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const LocalStorageKeys_1 = __importDefault(require("../../enums/LocalStorageKeys"));
const compare_1 = require("../../helper/compare");
const license_1 = require("../../helper/license");
const softwareColumns_1 = require("../../helper/softwareColumns");
const LicenseStore_1 = __importDefault(require("../../stores/LicenseStore"));
const TableTile_1 = __importDefault(require("../TableTile"));
const AssetsSoftwareHeaderButtons_1 = __importDefault(require("./AssetsSoftwareHeaderButtons"));
const AssetsSoftwareTableExpandedItem_1 = __importDefault(require("./AssetsSoftwareTableExpandedItem"));
class AssetsSoftware extends react_1.default.Component {
    contextReactionDisposer;
    selectedFilter = {
        filter: [],
        showDemoLicenses: true,
    };
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            filterableProductTypes: mobx_1.computed,
            filteredLicenses: mobx_1.computed,
            hasDemoLicenses: mobx_1.computed,
            selectedFilter: mobx_1.observable,
            softwareId: mobx_1.computed,
        });
        this.state = {
            allRowsExpanded: null,
        };
    }
    get softwareId() {
        return this.props.match?.params?.softwareId ?? null;
    }
    get filterableProductTypes() {
        return (0, array_1.simpleUnique)(LicenseStore_1.default.rootTableLicenses.map((license) => license.productType))
            .filter((type) => !!type)
            .sort(compare_1.localeCompare);
    }
    get hasDemoLicenses() {
        return LicenseStore_1.default.rootTableLicenses.some((license) => (0, license_1.isDemoLicense)(license));
    }
    get filteredLicenses() {
        return LicenseStore_1.default.rootTableLicenses
            .filter((license) => license.productType && this.selectedFilter.filter.includes(license.productType))
            .filter((license) => this.selectedFilter.showDemoLicenses || !(0, license_1.isDemoLicense)(license));
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('myassets_subpage_title', { title: (0, translation_1.t)('myassets.software.title') });
        this.contextReactionDisposer = (0, mobx_1.reaction)(() => AuthorizationStore_1.default.customerId, () => {
            LicenseStore_1.default.readMassiveLicenses().then((0, mobx_1.action)(() => {
                this.selectedFilter = {
                    filter: this.filterableProductTypes,
                    showDemoLicenses: true,
                };
            }));
            LicenseStore_1.default.clearDeactivateEllipsis();
        }, { fireImmediately: true });
    }
    componentWillUnmount() {
        this.contextReactionDisposer?.();
    }
    render() {
        if (LicenseStore_1.default.isLoading) {
            return (react_1.default.createElement("section", { className: "znd-asset" },
                react_1.default.createElement(LoadingSpinner_1.default, { center: true })));
        }
        // To trigger the observable values.
        LicenseStore_1.default.triggerable;
        LicenseStore_1.default.deactivateEllipsis.length;
        return (react_1.default.createElement("section", { className: "znd-asset" },
            react_1.default.createElement(TableTile_1.default, { columns: (0, softwareColumns_1.getSoftwareOverviewColumns)(), data: this.filteredLicenses, defaultSortField: 'name', expandableComponent: AssetsSoftwareTableExpandedItem_1.default, localStorageKey: LocalStorageKeys_1.default.softwareSort, onExpandedRow: (row) => this.rowIsExpanded(row.id), title: (0, translation_1.t)('myassets.software.title'), scrollInside: true, additionalHeaderButtonComponent: () => (react_1.default.createElement(AssetsSoftwareHeaderButtons_1.default, { onChange: (0, mobx_1.action)((value) => (this.selectedFilter = value)), options: {
                        filter: this.filterableProductTypes,
                        demoLicenseSelector: this.hasDemoLicenses,
                    }, rowsAreExpanded: this.state.allRowsExpanded ?? false, toggleExpand: () => this.toggleExpandAll(), value: this.selectedFilter })) })));
    }
    rowIsExpanded(rowId) {
        if (null === this.state.allRowsExpanded) {
            return this.softwareId === rowId;
        }
        return this.state.allRowsExpanded;
    }
    toggleExpandAll() {
        this.setState({
            ...this.state,
            allRowsExpanded: !this.state.allRowsExpanded,
        });
    }
}
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(AssetsSoftware));
